"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setLogout = exports.setRegistry = exports.logout = exports.registry = exports.IsPost = void 0;
const core = __importStar(require("@actions/core"));
exports.IsPost = !!process.env['STATE_isPost'];
exports.registry = process.env['STATE_registry'] || '';
exports.logout = /true/i.test(process.env['STATE_logout'] || '');
function setRegistry(registry) {
    core.saveState('registry', registry);
}
exports.setRegistry = setRegistry;
function setLogout(logout) {
    core.saveState('logout', logout);
}
exports.setLogout = setLogout;
if (!exports.IsPost) {
    core.saveState('isPost', 'true');
}
